var Curriculog = Curriculog || {};

Curriculog.HierarchyDropdownItemView = (function ($, _, Backbone, HierarchyDropdownItemView) {

	HierarchyDropdownItemView = Curriculog.DropdownItemView.extend({
		template: 'HierarchyList/hierarchyDropdownItem.html',

		initialize: function (options) {
			this.entity = options.entity;
			this.depth = options.depth;
			this.ineligible = options.ineligible;
			this.disableInactive = options.disableInactive;
			this.inactiveText = options.inactiveText;
			this.selectedValue = options.selectedValue;
			this.hasChildren = options.hasChildren;
			this.listenTo(this.entity, 'sync', this.updateName);
			this.render();
		},

		updateName: function () {
			var sanitizedModel = this.entity.getSanitizedModel();
			var escapedName = sanitizedModel.get('name');
			var depth = $(this.$el).data('depth');

			var dropdownValue = '';
			for (var i = 0; i < depth; i++) {
				dropdownValue += '&nbsp;&nbsp;&nbsp;\n';
			}

			dropdownValue += escapedName;
			$(this.$el).html(dropdownValue);
		},

		render: function (options) {
			var i = 0,
			    templateData = {
					entity: this.entity.toJSON(),
					depth: this.depth,
					inactiveText: this.inactiveText,
					hasChildren: this.hasChildren
				};

			// Pulling logic out of the template and into the view for better separation of concerns
			templateData.disabled = ((templateData.entity.status === 'inactive' && this.disableInactive)
				|| this.ineligible.indexOf(templateData.entity.id) !== -1)
				? ' disabled'
				: '';

			templateData.selected = this.selectedValue === templateData.entity.id ? ' selected' : '';

			templateData.depthOutput = '';

			for (i in _.range(templateData.depth)) {
				templateData.depthOutput += '&nbsp;&nbsp;&nbsp;';
			}

			var el = nunjucks.render(this.template, templateData);
			this.replaceElement(el);
		}
	});
	return HierarchyDropdownItemView;

})($, _, Backbone, Curriculog.HierarchyDropdownItemView || {});
